module.exports = __webpack_public_path__ + "img/37.3bd8108b.png";